export const creditsAPIUrls = {
  get: '/credits',
  create: '/credits',
  update: '/credits/{id}',
  delete: '/credits/{id}',
  updateCredit: '/users/update/{id}/credit'
} as const;
